import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Orders_Voucher } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ShowOrders from './Components/ShowOrders';
import ViewOrders from './Components/ViewOrders';
import moment from 'moment';
function Index({ propertyId, locale }) {
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [loading, setLoading] = useState(true);
    const [orderList, setOrderList] = useState([]);
    const [subOrderList, setSubOrderList] = useState([]);
    const [orderData, setOrderData] = useState([]);
    const [orderId, setOrderId] = useState();
    const [showOrderData, setShowOrderData] = useState(false);
    const [showOrdeList, setShowOrderList] = useState(true);
    const [showsubOrdeList, setShowSubOrderList] = useState(true);
    const handleViewOrderClick = (id, data) => {
        setOrderId(id);
        OrderData(id);
        setShowOrderData(true);
        setSubOrderList(data);
    };

    const onstartDateChnage = (date) => {
        setStartDate(date);
    };

    const onEndDateChnage = (date) => {
        setEndDate(date);
    };

    const handleSearchfilter = (search, status) => {
        console.log(search.length, status);
        LoadSearchOrderData(search.length === 0 ? "BMB" : search, status.trim());
    }

    const handleOrdersVoucherSubmit = () => {
        LoadData(startDate, endDate);
    };

    const LoadData = (startdate, enddate) => {
        setOrderList([]);
        let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
        let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}?fromDate=${fromDate}&toDate=${toDate}&groupId=${getGroupID()}&propertyId=${propertyId}`,
        })
            .then(res => {
                setOrderList(res.data);
                setLoading(false);
                console.log(res.data);
            })
            .catch(err => console.log('err', err));
    }

    const LoadSearchOrderData = (search, status) => {
        setOrderList([]);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}/search?status=${status}&search=${search}&groupId=${getGroupID()}&propertyId=${propertyId}`,
        })
            .then(res => {
                setOrderList(res.data);
                setLoading(false);
                console.log(res.data);
            })
            .catch(err => console.log('err', err));
    }

    const OrderData = (id) => {
        setOrderData([]);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}/detail?orderId=${id}`,
        })
            .then(res => {
                setOrderData(res.data.items);
                console.log(res.data.items);
            })
            .catch(err => console.log('err', err));
    }

    useEffect(() => {
        LoadData(startDate, endDate);
    }, [propertyId]);

    if (loading) {
        return (
            <Card className="d-flex flex-row mb-3">
                <CardBody>
                    <h4 style={{ textAlign: 'center' }}>Loading...</h4>
                </CardBody>
            </Card>
        );
    }

    return (
        <Fragment>
            {showOrdeList && <ShowOrders
                onstartDateChange={onstartDateChnage}
                onEndDateChange={onEndDateChnage}
                handleSubmit={handleOrdersVoucherSubmit}
                orderList={orderList}
                handleViewOrderClick={handleViewOrderClick}
                handleSearchfilter={handleSearchfilter}
            />}
            {showOrderData && <ViewOrders
                isopen={showOrderData}
                toggle={() => { setShowOrderData(false) }}
                orderData={orderData}
                subOrderList={subOrderList}
            />
            }
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));



